var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FB2E5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5605 7.50781V15H9.42578V7.50781H10.5605ZM10.0068 4.70508C10.1937 4.70508 10.3532 4.7666 10.4854 4.88965C10.6221 5.00814 10.6904 5.19499 10.6904 5.4502C10.6904 5.70085 10.6221 5.8877 10.4854 6.01074C10.3532 6.13379 10.1937 6.19531 10.0068 6.19531C9.81087 6.19531 9.64681 6.13379 9.51465 6.01074C9.38704 5.8877 9.32324 5.70085 9.32324 5.4502C9.32324 5.19499 9.38704 5.00814 9.51465 4.88965C9.64681 4.7666 9.81087 4.70508 10.0068 4.70508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPCircle);
export default __webpack_public_path__ + "static/media/PCircle.6c1912838ed00ebef08e6cae27d760aa.svg";
export { ForwardRef as ReactComponent };